export const apps = [
    "SocialBooster - Get Followers & Visibility",
    "SocialBooster - Get Fans & Visibility",
    "SocialBooster - Get Subscribers & Visibility"
]

export const company = [
    "Instagram©",
    "Tiktok© ",
    "Youtube©"
]